<template lang="pug">
  section.section
    .scroll-table.table-border
      b-table(class="table fixed"
        :data="accepting_order_items"
        :loading="loading"
        narrowed
        hoverable
        striped
        paginated
        per-page="10"
        )
        template(slot-scope="props")
          b-table-column(field="i" label="No." width="40")
            b-field {{ props.row.i }}
          b-table-column(field="id" label="ID" width="50" )
            span.tag
              b-field {{ props.row.id }}

          b-table-column(field="agency_shop_code" label="帳合 : 取次書店コード"  width="270" class="shop-code text-compact", :id="'agency_shop_code' + props.row.i")
            agency-shop-code-input(
              :input_name="'agency_shop_code' + props.row.i"
              :agency_shop_code.sync="props.row.agency_shop_code"
              :agency_code.sync="props.row.agency_code"
              :disabled="isDestroy(props.row)"
              :agencies="agencies"
              :errors="errors"
              :final_book_shop_agencies="final_book_shop_agencies"
              )

          b-table-column(field="isbn" label="書籍名 : ISBN" width="200" class="text-compact")
            isbn-input(
              :input_name="'isbn' + props.row.i"
              v-model="props.row.isbn"
              :disabled="isDestroy(props.row)"
              :errors="errors",
              :books="books"
            )

          b-table-column(field="order_number" label="発注数" width="60")
            b-field(:type="{'is-danger': error('order_number' + props.row.i, errors)}"
                  :message="errorMessageFor('order_number' + props.row.i, errors)")
              b-input(
                :data-vv-name="'order_number' + props.row.i"
                data-vv-as="発注数"
                type="number"
                size="is-small"
                v-model="props.row.order_number"
                :errors="errors"
                :disabled="isDestroy(props.row)"
              )

          b-table-column(field="kyakutyu_memo" label="客注メモ" width="300")
            b-field
              b-input(
                type="string"
                size="is-small"
                v-model="props.row.kyakutyu_memo"
                data-vv-as="客注メモ"
                :disabled="isDestroy(props.row)"
            )
          b-table-column(field="order_route_id" label="受注経路" width="170")
            accepting-order-route-id-input(
                :input_name="'order_route_id' + props.row.i"
                v-model="props.row.order_route_id"
                :disabled="isDestroy(props.row)"
                :errors="errors"
                :accepting_order_routes="accepting_order_routes")
          b-table-column(field="deliver_type_id" label="出荷属性" width="170")
            deliver-type-id-input(
                :input_name="'deliver_type_id' + props.row.i"
                v-model="props.row.deliver_type_id"
                :disabled="isDestroy(props.row) || setDeliverType(props.row)"
                :custom_errors="errors"
                :doValidate="false"
                :deliver_types="deliver_types")

          b-table-column(field="sales_person_id" label="営業担当" width="120")
            sales-person-id-input(
                :input_name="'sales_person_id' + props.row.i"
                v-model="props.row.sales_person_id"
                data-vv-as="営業担当"
                :disabled="isDestroy(props.row)"
                :sales_people="sales_people"
                :errors="errors"
                :data_vv_scope="'row' + props.row.i"
           )

          b-table-column(field="bibo" label="備考" width="300")
            b-field
              b-input(
                type="string"
                size="is-small"
                v-model="props.row.bibo"
                data-vv-as="備考"
                :disabled="isDestroy(props.row)"
              )
          b-table-column(field="shop_person" label="書店担当" width="100" sortable)
            b-field
              b-input(
                type="string"
                size="is-small"
                v-model="props.row.shop_person"
                data-vv-as="書店担当"
                :disabled="isDestroy(props.row)"
              )

          b-table-column(field="book_shop_name" label="書店名" width="150")
            b-field
              b-input(
                type="string"
                size="is-small"
                v-model="props.row.book_shop_name"
                data-vv-as="書店名"
                :disabled="isDestroy(props.row)"
            )

          b-table-column(field="bansen" label="番線" width="150")
            b-field
              b-input(
                type="string"
                size="is-small"
                v-model="props.row.bansen"
                data-vv-as="番線"
                :disabled="isDestroy(props.row)"
            )

          b-table-column(field="accepting_date" label="受注日"  width="100" sortable)
            b-field(:type="{'is-danger': error('accepting_date' + props.row.i, errors)}"
                  :message="errorMessageFor('accepting_date' + props.row.i, errors)")
              b-datepicker(
                :data-vv-name="'accepting_date' + props.row.i"
                data-vv-as="受注日"
                size="is-small"
                v-model="props.row.accepting_date"
                position="is-bottom-left"
                placeholder=""
                :disabled="isDestroy(props.row)"
              )

          b-table-column(field="" label="" width="40")
            b-field
              a.delete(@click="clickDeleteButton(props.row)")

    .field.is-grouped(v-if="isEditable")
      .control
        button(@click="addRow" class="button is-info" id="first-add-row")
          b-icon(pack="fas" custom-class="fa-sm fa-th-list")
          span
            | 1 行追加
      .control
        button(@click="is_component_modal_csv_import_active = true" class="button is-dark" id="first-csv-import")
          b-icon(pack="fas" custom-class="fa-sm fa-file-import")
          span
            | CSVインポート
        b-modal(:active.sync="is_component_modal_csv_import_active" has-modal-card)
          modal-csv-import-form(@importCsvArray="importCsvArray")
      .control
        button(@click="submit" class="button is-danger" id="first-confirm-button" :disabled="!hasRows")
          b-icon(pack="fas" custom-class="fa-sm fa-check")
          span
            | {{ button_label }}
      .control
        button(@click="submitDraft" v-if="!accepting_order" class="button is-danger" :disabled="!hasRows")
          b-icon(pack="fas" custom-class="fa-sm fa-plus")
          span
            | {{ draft_button_label }}
      .control(v-if="accepting_order")
        span.tag.is-white.is-medium
          | {{ accepting_order.sid }}
      .control(v-else-if="accepting_draft_order")
        span.tag.is-white.is-medium
          | {{ accepting_draft_order.sid }}



</template>

<script>

  import IsbnInput from 'inputs/isbn_input'
  import AgencyShopCodeInput from 'inputs/agency_shop_code_input'
  import AcceptingOrderRouteIdInput from 'inputs/accepting_order_route_id_input'
  import DeliverTypeIdInput from 'inputs/deliver_type_id_input'
  import SalesPersonIdInput from 'inputs/sales_person_id_input'
  import ModalCsvImportForm from 'components/accepting_orders/modal_csv_import_form'
  import AcceptingOrderItem from 'models/accepting_order_item'
  import CacheDispatcher from 'mixins/cache_dispatcher'
  import ErrorDisplayer from 'mixins/error_displayer'

  export default {
    name: 'abstract-accepting-order-fields',
    mixins: [CacheDispatcher, ErrorDisplayer],
    components: {
      IsbnInput,
      AgencyShopCodeInput,
      AcceptingOrderRouteIdInput,
      DeliverTypeIdInput,
      SalesPersonIdInput,
      ModalCsvImportForm
    },
    data() {
      return {
        accepting_order_items: [],
        loading: false,
        first_flag: true,
        is_component_modal_csv_import_active: false,
        errors: []
      }
    },
    props: {
      accepting_order_id: {
        type: String,
        required: false
      },
      accepting_draft_order_id: {
        type: String,
        required: false
      },
      action_name: {
        type: String,
        required: true
      },
      draft_action_name: {
        type: String,
        required: true
      },
      button_label: {
        type: String,
        required: true
      },
      draft_button_label: {
        type: String,
        required: true
      }
    },
    computed: {
      isEditable(){
        return this.action_name != 'show'
      },
      accepting_order(){
        var a = this.$store.getters['AcceptingOrder/record']
        if(this.first_flag && a){
          this.loading = false
          this.first_flag = false
          this.accepting_order_items = []
          a.accepting_order_items.forEach((item) => {
            this.accepting_order_items.push(Object.assign({}, new AcceptingOrderItem(item)))
          })
        }
        return a
      },
      accepting_draft_order(){
        var a = this.$store.getters['AcceptingDraftOrder/record']
        if(this.first_flag && a){
          this.loading = false
          this.first_flag = false
          this.accepting_order_items = []
          a.accepting_order_items.forEach((item) => {
            this.accepting_order_items.push(Object.assign({}, new AcceptingOrderItem(item)))
          })
        }
        return a
      },
      // accepting_order_items(){
      //   if(this.accepting_order){
      //     this.loading = false
      //     this.accepting_order.accepting_order_items.forEach((item) => {
      //               this.accepting_order_items.push(Object.assign({}, new AcceptingOrderItem(item)))
      //             })
      //   }else{
      //     return []
      //   }
      // },
      books(){  return this.$store.getters['Books/records'] },
      accepting_order_routes(){ return this.$store.getters['AcceptingOrderRoutes/records'] },
      agencies(){ return this.$store.getters['Agencies/records'] },
      final_book_shop_agencies(){ return this.$store.getters['FinalBookShopAgencies/records'] },
      shop_people(){ return this.$store.getters['ShopPeople/records'] },
      deliver_types(){ return this.$store.getters['DeliverTypes/records'] },
      sales_people(){ return this.$store.getters['SalesPeople/records'] },
      shinkan_deliver_type_id() {
        let type = this.deliver_types.filter(type => type.name == "印刷所在庫")
        if(type.length == 1)
         return type[0].id
      },
      hasRows() { return this.accepting_order_items.length > 0 }
    },
    methods:{
      addRow(event){
        this.accepting_order_items.push(Object.assign({}, new AcceptingOrderItem()))
      },
      importCsvArray(csv_array){
        AcceptingOrderItem.initialize({
          agencies: this.agencies,
          final_book_shop_agencies: this.final_book_shop_agencies,
          books: this.books,
          accepting_order_routes: this.accepting_order_routes,
          deliver_types: this.deliver_types,
          sales_people: this.sales_people
        })
        csv_array.forEach((item) => {
          let a = AcceptingOrderItem.importCsvArray(item)
          a._destroy = null
          this.accepting_order_items.push(Object.assign({}, a))
        })
        //this.$nextTick(() => {
        //    this.accepting_order_items.forEach((item) => {
        //      item._destroy = null
        //      this.$validator.validateAll(`row${item.i}`)
        //   })
        //})
      },

      submitRequest(url, id, action_name){
        var method = action_name == "new" ? 'post' : 'put'
        var url = action_name == "new" ? `/api/v1/${url}.json` : `/api/v1/${url}/${id}.json`
        var direct_flag = this.accepting_order ? this.accepting_order.direct_flag : this.accepting_draft_order ? this.accepting_draft_order.direct_flag : false

        this.accepting_order_items.forEach(item => {
          item.accepting_date = this.timeZoneHandledDate(item.accepting_date)
        })
        var params = {
          accepting_order: {
            accepting_draft_order_id: this.accepting_draft_order_id,
            confirming: null,
            direct_flag: direct_flag,
            accepting_order_items_attributes: this.accepting_order_items
          }
        }
        return this.$http({ method: method, url: url, data: params })
      },
      submit(){
        this.loading = true
        this.submitRequest("accepting_orders", this.accepting_order_id, this.action_name).then(({data}) => {
          this.accepting_order_items = []
          data.accepting_order_items.forEach((item) => {
            this.accepting_order_items.push(Object.assign({}, new AcceptingOrderItem(item)))
          })

          if(Object.keys(data.accepting_order.errors).length) {
            this.errors = []
            this.addErrors(data.accepting_order.errors)
            this.sortByError()
            this.loading = false
            this.$toast.open({
              message: '登録情報エラーです。登録情報を確認してください。',
              type: 'is-danger',
              position: 'is-bottom'
            })
            return
          }
          this.loading = false
          if((this.accepting_draft_order_id && this.action_name == "new") || this.accepting_order_id)
            window.location.href = '/users/accepting_orders?registered=true'

          this.popDeletedAcceptingOrderItems()

          if(this.accepting_order_items.length > 0) {
            this.$emit("confirming", true)
            this.$emit("onValid", data.accepting_order, this.accepting_order_items)
          }
        })
        .catch((error) => {
          this.loading = false
          throw error
        })
      },
      submitDraft() {
        this.loading = true
        this.submitRequest("accepting_draft_orders", this.accepting_draft_order_id, this.draft_action_name).then(({data}) => {
          this.loading = false
          window.location.href = `/users/accepting_draft_orders/${data.accepting_draft_order.id}/edit`
        })
        .catch((error) => {
          this.loading = false
          throw error
        })
      },
      popDeletedAcceptingOrderItems() {
        this.accepting_order_items = this.accepting_order_items.filter(item => { return item._destroy != '1' })
      },
      fetchAcceptingOrder(){
        if(this.accepting_order_id == null)
          return false

        this.loading = true
        this.$store.dispatch('AcceptingOrder/fetch', [ 'accepting_orders', this.accepting_order_id, { record_name: 'accepting_order' }])
        // this.$http.get(`/api/v1/accepting_orders/${this.accepting_order_id}.json`)
        //     .then(({data}) => {
        //       this.accepting_order = data.accepting_order
        //       data.accepting_order.accepting_order_items.forEach((item) => {
        //         this.accepting_order_items.push(Object.assign({}, new AcceptingOrderItem(item)))
        //       })
        //       this.loading = false
        //     })
        //     .catch((error) => {
        //       this.accepting_order = []
        //       this.accepting_order_items = []
        //       this.loading = false
        //       throw error
        //     })
      },
      fetchAcceptingDraftOrder() {
        if(this.accepting_draft_order_id == null)
          return false

        this.loading = true
        this.$store.dispatch('AcceptingDraftOrder/fetch', [ 'accepting_draft_orders', this.accepting_draft_order_id, { record_name: 'accepting_draft_order' }])
      },
      clickDeleteButton(accepting_order_item){
        if(accepting_order_item._destroy == null){
          accepting_order_item._destroy = '1'
        }else{
          accepting_order_item._destroy = null
        }
      },
      isDestroy(accepting_order_item){
        return accepting_order_item._destroy == "1"
      },
      addErrors(errors) {
        errors.forEach(error => {
          Object.keys(error).forEach(key => {
            this.errors.push({
            // accpeting_order_items.isbn0 なら isbn0にする
              field: key.replace(/.*\./g, ''),
              msg: error[key],
              i: key.replace(/[^0-9]/g, '')
            })
          })
        })
      },
      hasErrors () {
        if (this.errors.items.length) return true
          return false
      },
      sortByError() {
        let rows_with_error = Array.from(new Set(this.errors.map(error => Number(error.i))))
        // エラーを含むものを配列の前に持ってくる
        this.accepting_order_items.sort(function(a, b) {
          if(rows_with_error.includes(a.i) && !rows_with_error.includes(b.i)) {
            return -1
          }
          if(!rows_with_error.includes(a.i) && rows_with_error.includes(b.i)) {
            return 1
          }
          return 0
        })

      },
      timeZoneHandledDate(date) {
        let dateString = date.toString().replace(/[0-9]{2}:[0-9]{2}:[0-9]{2}/, '23:59:59')
        return new Date(dateString)
      },
      setDeliverType(row) {
        let bookExist = this.books.some(book => book.isbn == row.isbn && book.book_stock_status == '新刊')
        if(bookExist) {
          // 印刷所在庫に設定
          row.deliver_type_id = this.shinkan_deliver_type_id
          return true
        }
        return false
      }
    },
    created(){
      this.fetchAcceptingOrder()
      this.fetchAcceptingDraftOrder()
      this.dispatch_with_cache('Agencies/fetch', 'agencies', this.agencies)
      this.dispatch_with_cache('FinalBookShopAgencies/fetch', [ 'final_book_shop_agencies', null, { query: 'mode=simple' }], this.final_book_shop_agencies)
      this.$store.dispatch('Books/fetch', 'books')
      this.dispatch_with_cache('AcceptingOrderRoutes/fetch', 'accepting_order_routes', this.accepting_order_routes)
      this.$store.dispatch('DeliverTypes/fetch', 'deliver_types')
      this.dispatch_with_cache('SalesPeople/fetch', 'sales_people', this.sales_people)
    }
  }
</script>
